import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import { BASE_URL } from "app/services/auth-services";
import { Typography, Box, useTheme } from "@mui/material";
import { useGetDepartmentwiseEmployeeForAllQuery, useGetDepartmentwiseEmployeeQuery } from "app/services/RTK_Apis/dashbords/HomeDefaultApi";

const ChartOne = ({ partnerName, companyId, businessUnit, isMobile }) => {
  const theme = useTheme();
  const [statusLength, setStatusLength] = useState(true);

  const {
  data: allDepartmentData
} = useGetDepartmentwiseEmployeeForAllQuery(undefined, {
  skip: businessUnit !== "All BU",
});

const {
  data: departmentData
} = useGetDepartmentwiseEmployeeQuery(partnerName, {
  skip: businessUnit === "All BU" || !partnerName,
});

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "donut",
        toolbar: { show: false },
        animations: { enabled: true },
      },
      labels: [],
      colors: [],
      legend: {
        position: "bottom",
        fontSize: "13px",
        labels: { colors: theme.palette.text.primary },
        itemMargin: { horizontal: 8, vertical: 4 },
      },
      dataLabels: {
        enabled: true,
        style: { fontSize: "12px", fontWeight: 500 },
      },
      responsive: [
        {
          breakpoint: 768,
          options: {
            chart: { width: "100%" },
            legend: { position: "bottom" },
          },
        },
        {
          breakpoint: 480,
          options: {
            chart: { width: "100%" },
            legend: { fontSize: "10px", position: "bottom" },
          },
        },
      ],
      title: {
        text: "",
      },
    },
  });

  // 🎨 Generate bright, distinct colors dynamically
  function generateDistinctColors(count) {
    const baseColors = [
      "#FF5733", "#33B5FF", "#28A745", "#FFC300", "#8E44AD",
      "#E91E63", "#00BCD4", "#FF9800", "#4CAF50", "#9C27B0",
      "#F44336", "#009688", "#795548", "#3F51B5", "#CDDC39",
      "#2196F3", "#FF5722", "#607D8B", "#673AB7", "#C2185B"
    ];
    // If more departments than base colors, generate shades
    if (count <= baseColors.length) return baseColors.slice(0, count);

    const generated = [];
    for (let i = 0; i < count; i++) {
      const hue = Math.floor((360 / count) * i);
      generated.push(`hsl(${hue}, 70%, 50%)`); // evenly spaced hues
    }
    return generated;
  }

useEffect(() => {

  const apiData =
    businessUnit === "All BU"
      ? allDepartmentData
      : departmentData;

  if (!apiData) return;

  const labels = apiData.map(
    (item) => `${item.Department_Name} (${item.Employee_Count})`
  );

  const counts = apiData.map(
    (item) => Number(item.Employee_Count)
  );

  const colors = generateDistinctColors(counts.length);

  setChartData((prev) => ({
    ...prev,
    series: counts,
    options: {
      ...prev.options,
      labels,
      colors,
    },
  }));

  setStatusLength(counts.every((count) => count === 0));

}, [allDepartmentData, departmentData, businessUnit]);

  return (
    <>
      {/* <Typography variant={isMobile ? "h5" : "h4"} fontWeight={500}>Department Wise</Typography> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: { xs: 1, sm: 1 },
          // textAlign: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <Typography
          variant={isMobile ? "subtitle1" : "h5"}
          fontWeight={600}
          sx={{ mb: 1, textAlign: "center" }}
        >
          Department Wise
        </Typography>

        {chartData.series?.length > 0 && !statusLength ? (
          <Box
            sx={{
              width: "100%",
              maxWidth: isMobile ? "100%" : 480,
              height: "auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="donut"
              width={isMobile ? "100%" : 460}
              height={isMobile ? 300 : 320}
            />
          </Box>
        ) : (
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
              textAlign: "center",
              mt: 4,
            }}
          >
            Nothing to preview
          </Typography>
        )}
      </Box>
    </>
  );
};

export default ChartOne;
